export default __webpack_public_path__ + "static/media/new-zealand.773f7dab.svg";